module.exports = __webpack_public_path__ + "static/media/ph.03c78e38.svg";